import Vue from "vue";
import axios from "axios";

export async function FetchParentPointsBySkill({commit}, parentId){
  await Vue.axios({
    method: "Get",
    url: `/parent/${parentId}/points_per_skill/`
  })
  .then(response=>{
    commit("setParentPointBySkill",response.data)
  })
}

export async function FetchParentPointsPerTime({commit}, params){
  let parentId = params.parentId
  let startDate = params.startDate
  let weekly = params.weekly
  
  let url = `/parent/${parentId}/points_per_time/`

  url+=`?toggle=${weekly?'weekly':'daily'}`
  if(startDate){
    url+=`&start_date=${startDate}`
  }
  console.log("new",url)
  await Vue.axios({
    method: "Get",
    url: url
  })
  .then(response=>{
    console.log("parent per time",response.data)
    commit("setParentPointPerTime",response.data)
  })
  .catch(error=>{
    commit("error",error)
  })
}

export async function FetchParentPoints({ commit }, parentId) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/parent/${parentId}/progress/`
    })
    .then(response => {
      commit("setParentTotalPoints", response.data['total_points']);
      commit("setParentPointsSum", response.data['points_skill_sum']);
      commit("setParentPointsMean", response.data['points_general_mean']);
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchParentPointsByDate({ commit }, data) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/parent/${data.userId}/progress/?start_date=${data.date}`
    })
    .then(response => {
      commit("setParentTotalPoints", response.data['total_points']);
      commit("setParentPointsSum", response.data['points_skill_sum']);
      commit("setParentPointsMean", response.data['points_general_mean']);
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchChildrenProgress({ commit }, parentId) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/parent/${parentId}/progress_children/`
    })
    .then(response => {
      response.data.forEach(element => {
        commit("setChildPoints", { id: element['child'], data: { "name": element.childName, "points": element.progress } });
        commit("setChildGoalsApproved", { id: element['child'], data: { "name": element.childName, "approved": element.challenges_approved, "disapproved": element.challenges_disapproved } });
      });
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchChildrenProgressByDate({ commit }, data) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/parent/${data.userId}/progress_children/?start_date=${data.date}`
    })
    .then(response => {
      response.data.forEach(element => {
        commit("setChildPoints", { id: element['child'], data: { "name": element.childName, "points": element.progress } });
        commit("setChildGoalsApproved", { id: element['child'], data: { "name": element.childName, "approved": element.challenges_approved, "disapproved": element.challenges_disapproved } });
      })
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchChildPoints({ commit }, child) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/child/${child}/progress/`
    })
    .then(response => {
      commit("setChildUniquePoints", { data: response.data });
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchChildPointsByDate({ commit }, data) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/child/${data.userId}/progress/?start_date=${data.date}`
    })
    .then(response => {
      commit("setChildUniquePoints", { data: response.data });
    })
    .catch(error => {
      commit("error", error);
    });
}


export async function FetchChildrenStarProgress({commit}, params){
  let parentId = params.parentId
  let startDate = params.startDate
  
  let url = `/parent/${parentId}/children_stars_progress/`

  if(startDate){
    url+=`?start_date=${startDate}`
  }

  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: url
    })
    .then(response => {
      commit("SetChildStars", response.data);
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function fetchStarsProgressByChildId({ commit }, { parentId, childId, startDate }) {
  try {
    const { data } = await axios.get(
      `/parent/${parentId}/children_stars_progress/?start_date=${startDate}&child_id=${childId}`,
    );
    commit('setStarsProgressById', { data, childId });
  } catch (error) {
    throw { info: 'Progress data request failed. Try again.', error };
  }
}

export async function FetchChildrenGoalsProgress({commit}, params){
  let parentId = params.parentId
  let startDate = params.startDate  
  let url = `/parent/${parentId}/children_challenges_progress/`
  if(startDate){
    url+=`?start_date=${startDate}`
  }
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: url
    })
    .then(response => {
      console.log("goals ",response.data)
      commit("SetChildGoals", response.data);
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchChildStars({commit}, params){
  const {childId:userId, startDate} = params;
  let url = `/child/${userId}/stars_progress/`;

  if(startDate){
    url+=`?start_date=${startDate}`
  }

  commit("cleanErrors");
  try {
    const {data} = await axios.get(url);
    commit("SetChildOwnStars", data);
  } catch (error) {
    commit("error", error);
    
  }
}

export async function fetchPopups({commit}) {
  try {
    const {data:parent} = await axios.get('/pop/progress_parent_pop/');
    const {data:child} = await axios.get('/pop/progress_child_pop/');
    commit("setProgressPopups", {parent, child})
  } catch (error) {
    commit("error", error);
    throw new Error('[Request]: I have a problem when try fetch the popups...');
  }
}